<template>
  <div :class="errorFallbackclasses">
    <h2 class="mb-4 text-3xl font-bold text-gray-800">
      {{ t('errorFallbackDefault.title') }}
    </h2>
    <p class="mb-4 text-gray-600">{{ t('errorFallbackDefault.message') }}</p>
    <Button @click="reloadPage">{{ t('errorFallbackDefault.button') }}</Button>
  </div>
</template>

<script setup lang="ts">
import { cn } from '@/utils'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const props = defineProps<{ place?: 'global' }>()
const errorFallbackclasses = computed(() => {
  return cn('flex flex-col items-start justify-start', {
    'h-screen items-center justify-center': props.place === 'global',
  })
})

const reloadPage = () => {
  window.location.reload()
}
</script>
